import { BaseService, CommandService } from "Service";
import {
    IfcImportClient,
    ImportType,
    ImportResult,
    ImportRequest,
    ExportType,
    IfcExportClient,
    IfcExportRequest,
    IfcExportResult,
    DownloadFile,
    DownloadFileRequest,
} from "Service/Client";
import { Configuration } from "Configuration";

/**
 * @hidden
 */
export class IFCService extends BaseService {
    public getImportType(importTypeId: number): Promise<ImportType> {
        let params = CommandService.getPageTokenParameter();
        let client = new IfcImportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<ImportType>((resolve, reject) => {
                /*let xhr = */ client.getImportType(
                    importTypeId,
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    public getExportType(exportTypeId: number): Promise<ExportType> {
        let params = CommandService.getPageTokenParameter();
        let client = new IfcExportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<ExportType>((resolve, reject) => {
                /*let xhr = */ client.getExportType(
                    exportTypeId,
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    public import(importTypeId: number, uploadOnly: boolean, parameterValues: { [key: string]: string }): Promise<ImportResult> {
        let params = <ImportRequest>CommandService.getPageTokenParameter();
        params.ParameterValues = parameterValues;
        params.UploadOnly = uploadOnly;

        let client = new IfcImportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<ImportResult>((resolve, reject) => {
                /*let xhr = */ client.import(
                    importTypeId,
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    public export(exportTypeId: number, parameterValues: { [key: string]: string }): Promise<IfcExportResult> {
        let params = <IfcExportRequest>CommandService.getPageTokenParameter();
        params.ParameterValues = parameterValues;

        let client = new IfcExportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<IfcExportResult>((resolve, reject) => {
                /*let xhr = */ client.export(
                    exportTypeId,
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );

                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    public getDownloadFile(ieSessionGuid: string, fileName: string): Promise<DownloadFile> {
        let params = <DownloadFileRequest>CommandService.getPageTokenParameter();
        params.IeSessionGuid = ieSessionGuid;
        params.FileName = fileName;

        let client = new IfcExportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<IfcExportResult>((resolve, reject) => {
                /*let xhr = */ client.getFile(
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );

                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
